import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route
} from 'react-router';
import { RootErrorBoundary, Loader } from '@link/share/components';

const ResetPassword = lazy(() => import('@link/auth/views/ResetPassword'));
const NotFound = lazy(() => import('@link/share/views/NotFound'));

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback={<Loader />}>{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route path="/reset-password" element={lazyView(<ResetPassword />)} />
      <Route path="*" element={lazyView(<NotFound />)} />
    </Route>
  )
);

export default router;
